module.exports = function getResource(label, vars = []) {
    const resources = {
        addToBasket: 'Add to Basket',
        addAllToBasket: 'Add All to Basket',
        addedToBasket: 'Added to Basket',
        add: 'Add',
        added: 'Added',
        remove: 'Remove',
        exclusive: 'Exclusive',
        storePickup: 'for Store Pickup',
        standardShipping: 'for Standard Shipping',
        sameDayDelivery: 'for Same-Day Delivery',
        sameDayCustomDelivery: `for ${vars[0]}`,
        autoReplenish: `Deliver every ${vars[0]}`,
        alreadyAddedKohls: 'Already Added to Basket'
    };
    return resources[label];
};
